var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal modal-custom-team active" }, [
    _c("div", { staticClass: "modal-dialog" }, [
      _c("span", {
        staticClass: "icon-close",
        on: { click: _vm.closePreview },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-body" }, [
          _c("img", {
            attrs: {
              src: "/static-assets/images/share-images/" + _vm.image,
              alt: "",
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }